import React, { useState } from "react";

import TabMenu from "~/common/components/TabMenu";
import { Case, If } from "~/common/components/If";

// Assets
import "~/assets/sass/pages/mypage/signature/signature.scss";
import File from "./components/File";
import Draw from "./components/Draw";
import { useTranslation } from "react-i18next";

const SignatureUploadModal = ({ setModalToggle, userSignatureRequest }) => {
	const { t } = useTranslation();
	const [currentTab, setCurrentTab] = useState("file");

	const tabMenuList = [
		{ id: "file", title: t("pages.myPage.SignaturePage.upload.SignatureUploadModal.img") },
		{ id: "draw", title: t("pages.myPage.SignaturePage.upload.SignatureUploadModal.draw") },
	];

	return (
		<>
			<div className="modal-content">
				<div className={`signature-${currentTab}`}>
					<TabMenu
						tabItem={tabMenuList}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
					<If condition={currentTab} {...{ setModalToggle, userSignatureRequest }}>
						<Case condition={"file"}>
							<File />
						</Case>
						<Case condition={"draw"}>
							<Draw />
						</Case>
					</If>
				</div>
			</div>
		</>
	);
};

export default SignatureUploadModal;
